export enum TournamentSkillEnum {
  Competitive = "COMPETITIVE",
  Casual = "CASUAL",
}
